import React from 'react';
import {
  IonAvatar,
  IonButton,
  IonButtons,
  IonIcon,
  IonItem,
  IonLabel,
  IonList,
  useIonPopover,
} from '@ionic/react';
import { personCircleOutline, logOutOutline } from 'ionicons/icons';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function UserMenu() {
  const { user, logout } = useAuth();
  const { t } = useLanguage();

  const initials = user?.username
    ? user.username
        .split(' ')
        .map((part) => part[0]?.toUpperCase())
        .join('')
        .slice(0, 2)
    : 'CN';

  const PopoverContent: React.FC<{ onDismiss: () => void }> = ({ onDismiss }) => (
    <IonList>
      <IonItem lines="none">
        <IonAvatar slot="start">
          <div
            style={{
              width: '40px',
              height: '40px',
              borderRadius: '50%',
              background: 'var(--ion-color-primary)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontWeight: 600,
            }}
          >
            {initials}
          </div>
        </IonAvatar>
        <IonLabel>
          <h2>{user?.username ?? 'Cafe CN'}</h2>
          <p>{t('account')}</p>
        </IonLabel>
      </IonItem>
      <IonItem
        button
        detail={false}
        lines="full"
        onClick={() => {
          onDismiss();
          logout();
        }}
      >
        <IonIcon icon={logOutOutline} slot="start" />
        <IonLabel>{t('logout')}</IonLabel>
      </IonItem>
    </IonList>
  );

  const [present, dismiss] = useIonPopover(PopoverContent, {
    onDismiss: () => dismiss(),
  });

  return (
    <IonButtons slot="end">
      <IonButton
        onClick={(event) =>
          present({
            event: event.nativeEvent,
          })
        }
      >
        <IonIcon icon={personCircleOutline} slot="icon-only" />
      </IonButton>
    </IonButtons>
  );
}
